// import React, { useContext, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { LogIn, Lock, User } from "react-feather";
// import man from "../../../assets/images/blank_profile.png";
// import Modal from 'react-bootstrap/Modal';
// import { LI, UL, P } from "../../../AbstractElements";
// import { useTranslation } from "react-i18next";
// import PrivilegeContext from "../../../_helper/PrivilegeContext";
// import { useClinicAdmin } from "../../../_helper/ClinicProvider";
// // import { useSocket } from "../../../_helper/SocketProvider";
// import { useLoader } from './../../../_helper/LoaderContext';
// import axiosInstance from "../../../interceptor/intercetptor-inctence";
// import { useLab } from "../../../_helper/PharmacyProvider";
// import S3ImageLoader from "../../../S3ImageLoader"
// import { Button, Form } from "react-bootstrap";
// import { logOutUser } from "../../../Services/LogOut";
// import MoonLight from "./MoonLight";
// import FullScreenToggle from "./FullScreenToggle";
// import { useCollection } from "../../../_helper/dailyCollection";
// import { useCurrency } from "../../../_helper/currencyContext";


// const UserHeader = () => {
//   const history = useNavigate();
//   const [name, setName] = useState("");
//   const { t } = useTranslation()
//   const { setLoading } = useLoader();
//   const imageBaseURL = process.env.REACT_APP_BASE_URL_NAKBHO;
//   const { setUserPrivileges } = useContext(PrivilegeContext);
//   const { clinicAdmin, setClinicAdmin } = useClinicAdmin();
//   const { currentLab, setCurrentLab } = useLab();
//   const [amount, setAmount] = useState("");
//   const [note, setNote] = useState("");
//   // const socket = useSocket();
//   const [show, setShow] = useState(false);
//   const {daily} = useCollection();
//   const { getCurrencySymbol } = useCurrency()

//   const logoutUserOld = async () => {
//     try {
//       setLoading(true);
//       const response = await axiosInstance.get(`clinic_admin/logout/${clinicAdmin._id}`);
//       if (response.data.status === "success") {
//         // Logout();
//       }
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const openModel = () => {
//     setShow(true)
//   }

//   const logoutUser = () => {
//     setUserPrivileges(null);
//     localStorage.removeItem("profileURL");
//     localStorage.removeItem("currentLabAuth");
//     localStorage.removeItem("currentLab");
//     localStorage.removeItem("Name");
//     localStorage.removeItem("header");
//     localStorage.setItem("authenticated", false);
//     setCurrentLab(null);
//     history(`${process.env.PUBLIC_URL}/login`, { replace: true });
//   };

//   const changePassword = () => {
//     history(`${process.env.PUBLIC_URL}/change-password`);
//   };

//   const updateProfile = () => {
//     history(`${process.env.PUBLIC_URL}/update-profile`);
//     // history(`${process.env.PUBLIC_URL}/profile`);
//   };

//   const submitAmount = async () => {
//     setLoading(true);
//     try {
//       const payload = {
//         closingAmount: {
//           [currentLab.baseCurrency]: amount,
//         },
//         note: note
//       }
//       const res = await logOutUser(payload);
//       if (res.data.success == true) {
//         logoutUser()
//       }
//     } catch (error) {
//       console.log(error);
//     } finally {
//       setLoading(false)
//     }
//     setShow(false);
//   }

//   return (
//     <>
//       <li className="py-0 profile-nav onhover-dropdown pe-0">
//         <div className="media profile-media" style={{ alignItems: 'center' }}>
//           <S3ImageLoader
//             className="m-0 b-r-10"
//             fileName={currentLab?.contact_person?.profile_picture}
//             style={{ height: '32px', width: '32px', objectFit: 'cover' }}
//             alt="profile"
//             fallbackSrc={man}
//           />
//           <div className="media-body">
//             <span>{currentLab?.facility_name || name}</span>
//           </div>
//         </div>
//         <UL attrUL={{ className: "simple-list profile-dropdown onhover-show-div" }}>
//           <LI attrLI={{ onClick: updateProfile }}>
//             <User />
//             <span>{t("profile")}</span>
//           </LI>
//           <LI>
//             <MoonLight />
//           </LI>
//           <LI>
//             <FullScreenToggle />
//           </LI>
//           <LI attrLI={{ onClick: openModel }}>
//             <LogIn />
//             <span>{t("logOut")}</span>
//           </LI>
//         </UL>
//       </li>
//       {/* Today collection amount modal */}
//       <Modal show={show} onHide={() => setShow(false)} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Enter Today's Collection Amount</Modal.Title>
//         </Modal.Header>

//         <Modal.Body>
//           {/* AMOUNT */}
//           <Form.Group className="mb-3">
//             <Form.Label>Amount</Form.Label>
//             <Form.Control
//               type="number"
//               placeholder="Enter amount"
//               value={amount}
//               onChange={(e) => setAmount(e.target.value)}
//             />
//           </Form.Group>

//           {/* NOTE */}
//           <Form.Group className="mb-3">
//             <Form.Label>Note</Form.Label>
//             <Form.Control
//               as="textarea"
//               rows={3}
//               placeholder="Enter note"
//               value={note}
//               onChange={(e) => setNote(e.target.value)}
//             />
//           </Form.Group>
//         </Modal.Body>

//         <Modal.Footer>
//           <Button
//             variant="primary"
//             onClick={submitAmount}
//           >
//             Submit
//           </Button>

//           <Button variant="secondary" onClick={() => setShow(false)}>
//             Close
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </>
//   );
// };

// export default UserHeader;

import React, { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Calendar, CreditCard, LogIn, Package, User } from "react-feather";
import man from "../../../assets/images/blank_profile.png";
import Modal from "react-bootstrap/Modal";
import { LI, UL } from "../../../AbstractElements";
import { useTranslation } from "react-i18next";
import PrivilegeContext from "../../../_helper/PrivilegeContext";
import { useClinicAdmin } from "../../../_helper/ClinicProvider";
import { useLoader } from "../../../_helper/LoaderContext";
import axiosInstance from "../../../interceptor/intercetptor-inctence";
import { useLab } from "../../../_helper/PharmacyProvider";
import S3ImageLoader from "../../../S3ImageLoader";
import { Button, Form } from "react-bootstrap";
import { logOutUser } from "../../../Services/LogOut";
import MoonLight from "./MoonLight";
import FullScreenToggle from "./FullScreenToggle";
import { useCollection } from "../../../_helper/dailyCollection";
import { useCurrency } from "../../../_helper/currencyContext";
import Swal from "sweetalert2";
import { Label } from "reactstrap";
import { toast } from "react-toastify";
import { useLicense } from "../../../_helper/LicenseContext";
import { upgradPlan } from "../../../Components/LabProfile/service/profile-service";

const UserHeader = () => {
  const history = useNavigate();
  const { t } = useTranslation();
  const { setLoading } = useLoader();
  const { setUserPrivileges } = useContext(PrivilegeContext);
  const { clinicAdmin } = useClinicAdmin();
  const { currentLab, setCurrentLab } = useLab();
  const { getCurrencySymbol, convertCurrency } = useCurrency();
  const { daily } = useCollection();
  const [licenseKey, setLicenseKey] = useState("");
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const [amounts, setAmounts] = useState({});
  const [note, setNote] = useState("");
  const [error, setError] = useState("")
  const { clearLicense } = useLicense()
  const { saveLicenseToken } = useLicense()
  const keyLicense = localStorage.getItem("licenseKey")
  /* ---------------- LOGOUT API (OLD) ---------------- */
  const logoutUserOld = async () => {
    try {
      setLoading(true);
      await axiosInstance.get(`clinic_admin/logout/${clinicAdmin._id}`);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  /* ---------------- OPEN MODAL ---------------- */
  const openModel = () => {
    setAmounts({});
    setNote("");
    setShow(true);
  };

  /* ---------------- FINAL LOGOUT ---------------- */
  const logoutUser = async () => {
    await clearLicense();
    setUserPrivileges(null);
    localStorage.clear();
    localStorage.setItem("authenticated", false);
    setCurrentLab(null);
    history(`${process.env.PUBLIC_URL}/login`, { replace: true });
  };

  /* ---------------- NAVIGATIONS ---------------- */
  const updateProfile = () => {
    history(`${process.env.PUBLIC_URL}/update-profile`);
  };
  const currentPlan = () => {
    history(`${process.env.PUBLIC_URL}/current-plan`);
  };

  /* ---------------- HANDLE AMOUNT CHANGE ---------------- */
  const handleAmountChange = (currency, value) => {
    setAmounts((prev) => ({
      ...prev,
      [currency]: value,
    }));
  };

  /* ---------------- SUBMIT COLLECTION ---------------- */
  const submitAmount = async () => {
    setLoading(true);
    try {
      const payload = {
        closingAmount: amounts,
        note: note,
      };

      const res = await logOutUser(payload);
      if (res?.data?.success === true) {
        logoutUser();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
    setShow(false);
  };

  // currency conve
  const getConvertedDailyAmount = (currency) => {
    if (!daily || Object.keys(daily).length === 0) {
      return '0.00';
    }

    return Number(daily[currency] || 0).toFixed(2);
  };

  const OpenUpdateModal = () => {
    setShow1(true);
    console.log(currentLab)
  }

  const handleUpdate = async () => {
    if (licenseKey == "") {
      setError("Please enter license key")
      return
    }
    if (currentLab.licenseKey == licenseKey.trim()) {
      setError("")
      Swal.fire({
        icon: 'info',
        text: "Please Enter new license key"
      })
    } else {
      setError("")
      Swal.fire({
        icon: 'info',
        title: "Are you sure?",
        text: 'Changing your plan may impact available features and limits. Please confirm to proceed.',
        showCancelButton: true,
        confirmButtonText: "Yes, Upgrade",
        cancelButtonText: "Cancel",
      }).then(async (result) => {
        if (result.isConfirmed) {
          setLoading(true)
          try {
            const payload = {
              oldLicenseKey: keyLicense,
              newLicenseKey: licenseKey,
              user: {
                id: currentLab._id,
                name: currentLab.contact_person.first_name + " " + currentLab.contact_person.last_name,
              }
            }
            const res = await upgradPlan(payload)
            if (res.data.success == true) {
              localStorage.setItem("licenseKey", licenseKey)
              toast.success(res.data.message);
              setLicenseKey("")
              await saveLicenseToken(res.data.data.data.token);
              setShow1(false);
            }
          } catch (error) {
            console.log(error)
          } finally {
            setLoading(false)
          }
        }
      })
    }
  };

  const convertion = () => {
    history(`${process.env.PUBLIC_URL}/conversion-setting`);
  }

  const openDateTimeFormat = () => {
    history(`${process.env.PUBLIC_URL}/date-time-format`);
  }
  return (
    <>
      {/* ================= HEADER PROFILE ================= */}
      <li className="py-0 profile-nav onhover-dropdown pe-0">
        <div className="media profile-media" style={{ alignItems: "center" }}>
          <S3ImageLoader
            className="m-0 b-r-10"
            fileName={currentLab?.logo}
            style={{ height: "32px", width: "32px", objectFit: "cover" }}
            alt="profile"
            fallbackSrc={man}
          />
          <div className="media-body">
            <span>{currentLab?.facility_name}</span>
          </div>
        </div>

        <UL attrUL={{ className: "simple-list profile-dropdown onhover-show-div" }}>
          <LI attrLI={{ onClick: updateProfile }}>
            <User />
            <span>{t("profile")}</span>
          </LI>
          {currentLab.isAdmin == true && (
            <>
              <LI attrLI={{ onClick: OpenUpdateModal }} >
                <CreditCard />
                <span>{t("Upgrade Plan")}</span>
              </LI>
            </>
          )}
          <LI attrLI={{ onClick: currentPlan }} >
            <Package />
            <span>{t("Package Benefits")}</span>
          </LI>

          <LI>
            <MoonLight />
          </LI>

          <LI>
            <FullScreenToggle />
          </LI>

          <LI attrLI={{ onClick: convertion }}>
            <CreditCard />
            <span>Conversion</span>
          </LI>
          <LI attrLI={{ onClick: openDateTimeFormat }}>
            <Calendar />
            <span>Date & Time</span>
          </LI>
          <LI attrLI={{ onClick: openModel }}>
            <LogIn />
            <span>{t("logOut")}</span>
          </LI>
        </UL>
      </li>

      {/* ================= TODAY COLLECTION MODAL ================= */}
      <Modal show={show} onHide={() => setShow(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Enter Today's Collection</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* ===== CURRENCY INPUTS ===== */}
          {currentLab?.allowedCurrencies?.map((currency) => (
            <Form.Group className="mb-3" key={currency}>
              {/* <Form.Label> */}
              <div className="tw-flex tw-justify-between">
                <div className="tw-font-bold">
                  Amount
                </div>
                <div className="">
                  {getCurrencySymbol(currency)}  {getConvertedDailyAmount(currency)}
                </div>
              </div>
              {/* </Form.Label> */}
              <Form.Control
                type="number"
                placeholder={`Enter amount in ${currency}`}
                value={amounts[currency] || ""}
                onChange={(e) =>
                  handleAmountChange(currency, e.target.value)
                }
              />
            </Form.Group>
          ))}

          {/* ===== NOTE ===== */}
          <Form.Group className="mb-3">
            <Form.Label>Note</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              placeholder="Enter note"
              value={note}
              onChange={(e) => setNote(e.target.value)}
            />
          </Form.Group>

          {/* ===== BASE CURRENCY INFO ===== */}
          {/* {currentLab?.baseCurrency && (
            <small className="text-muted">
              Base Currency: {currentLab.baseCurrency}
            </small>
          )} */}
        </Modal.Body>

        <Modal.Footer>
          <Button variant="primary" onClick={submitAmount}>
            Submit & Logout
          </Button>

          <Button variant="secondary" onClick={() => setShow(false)}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>


      <Modal show={show1} onHide={() => setShow1(false)} centered>
        <Modal.Header>
          <Modal.Title>Upgrade Plan</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="">Current License Key: <span className='tw-font-bold'>{keyLicense}</span></div>
          <div className="form-group mt-2">
            <Label>License Key</Label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter new license key"
              value={licenseKey}
              onChange={(e) => setLicenseKey(e.target.value)}
            />
            <span className="tw-text-red-500">{error}</span>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleUpdate}>
            Upgrade
          </Button>
          <Button variant="secondary" onClick={() => setShow1(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default UserHeader;
